import { render } from "./ServiciosProgramadosListadoSolicitudesDetalle.vue?vue&type=template&id=769c79e5&ts=true"
import script from "./ServiciosProgramadosListadoSolicitudesDetalle.vue?vue&type=script&lang=ts"
export * from "./ServiciosProgramadosListadoSolicitudesDetalle.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__